module.exports = __webpack_public_path__ + "images/illustrations/reach-icon-graph-35eb0140ac885a30c2db1e9706c711c1.svg";